var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: {
          border: "1px solid #aaa",
          padding: "10px 10px",
          "margin-top": "30px"
        }
      },
      [_vm._v("\n    波次校验设置\n  ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticStyle: {
          border: "1px solid #aaa",
          "border-top": "0",
          padding: "20px"
        }
      },
      [
        _c(
          "el-form",
          [
            _c(
              "el-form-item",
              {
                staticClass: "open-weight",
                attrs: { label: "波次校验必须称重: " }
              },
              [
                _c("el-switch", {
                  attrs: { "active-value": "1", "inactive-value": "2" },
                  model: {
                    value: _vm.form.open_weight,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "open_weight", $$v)
                    },
                    expression: "form.open_weight"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "express-node-wrap" },
                  [
                    _c("span", { staticClass: "express-node-label" }, [
                      _vm._v("波次锁定时系统提前根据预测包裹重量分配快递:")
                    ]),
                    _vm._v(" "),
                    _c("el-switch", {
                      attrs: { "active-value": "1", "inactive-value": "2" },
                      model: {
                        value: _vm.form.set_express_node,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "set_express_node", $$v)
                        },
                        expression: "form.set_express_node"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "称重差异容错比例: " } },
              [
                _vm._v(
                  "\n        「称重重量」与「计算重量」的差异超过±\n        "
                ),
                _c("ys-input", {
                  staticStyle: { width: "90px" },
                  attrs: {
                    pattern: "positiveInt",
                    min: "1",
                    max: "100",
                    disabled:
                      _vm.form.open_weight === _vm.OPEN_WEIGHT_STATUS.CLOSED
                  },
                  model: {
                    value: _vm.form.weight_rate,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "weight_rate", $$v)
                    },
                    expression: "form.weight_rate"
                  }
                }),
                _vm._v("\n        %，就提示重新称重。\n        "),
                _c("div", { staticStyle: { color: "gray" } }, [
                  _vm._v(
                    "\n          （举例：包裹计算重量为1000克，设置为±30%，称重重量小于700克或大于1300克的时候就会报错）\n        "
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "是否开启差异出库: " } },
              [
                _c("el-switch", {
                  attrs: { "active-value": "1", "inactive-value": "0" },
                  model: {
                    value: _vm.form.is_open,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "is_open", $$v)
                    },
                    expression: "form.is_open"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { label: "差异出库容错比例: " } },
              [
                _vm._v("\n        低于等于\n        "),
                _c("el-input", {
                  staticStyle: { width: "120px" },
                  attrs: { disabled: !Number(_vm.form.is_open) },
                  model: {
                    value: _vm.form.rate,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "rate", $$v)
                    },
                    expression: "form.rate"
                  }
                }),
                _vm._v(
                  "\n        （填写小数即可，如0.02即为2%，即100件允许有2件误差）\n      "
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-button",
          { attrs: { type: "primary" }, on: { click: _vm.submit } },
          [_vm._v("保存")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0535bee8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0535bee8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wavepicking/WaveCheckSetting.vue
// module id = null
// module chunks = 